import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { getSchedule, addMemberToSchedule, getSpecifySchedule, updateAccountPresenze } from './supabase';
const Card = (props) => {
    const navigation = useNavigate()
    const [activities, setActivities] = useState([])
    const [showModal, setShowModal] = useState(false)
    const [infoData, setInfoData] = useState([{}])
    const nome = localStorage.getItem('nome')
    const mail = localStorage.getItem('mail')
    const presenze = localStorage.getItem('presenze')
    const today = new Date()
    const formatToday = today.toISOString().split('T')[0]

    const get = async () => {
        const data = await getSchedule();
        setActivities(data);
    };

    const memo = useMemo(() => {
        const futureActivities = activities.filter(a => a.date >= formatToday);
        const pastActivities = activities.filter(a => a.date < formatToday);
        futureActivities.sort((a, b) => new Date(a.date) - new Date(b.date));
        pastActivities.sort((a, b) => new Date(b.date) - new Date(a.date));
        console.log('future', futureActivities);
        return props.now ? pastActivities : futureActivities;
    }, [activities, props.now, formatToday]);


  

    console.log('today', memo)
    useEffect(() => { 
        get()
    }, [])

    const addMember = async (id, nome, members) => {
        if (!nome || nome === '' || nome === undefined || nome === null) {
            alert('Effettua di nuovo il login')
            navigation('/')
            return
        }


      if (!members?.includes(nome)) {
            const allMembers = [...members, nome]
            await addMemberToSchedule(id, allMembers)
            const newPresenze = parseInt(presenze) + 1
            await localStorage.setItem('presenze', newPresenze)
            await updateAccountPresenze(mail, newPresenze)
            get()
            alert('Prenotazione effettuata')
        } else {
            // const removeMember = members.filter(m => m !== nome)
            // await addMemberToSchedule(id, removeMember)
            // const newPresenze = parseInt(presenze) - 1
            // await localStorage.setItem('presenze', newPresenze)
            // await updateAccountPresenze(mail, newPresenze)
            // get()
            alert('Per cancellare la prenotazione contatta il direttivo')
        }
    }

    const specifySchedule = async (id) => {
        const data = await getSpecifySchedule(id)
        await setInfoData(data)
        await setShowModal(!showModal)

    }




    return (
        <div className='mb-24 w-full'>
            {showModal && <div className='fixed z-50 top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center'>
                <div className='bg-[#1E2021] w-full h-fit flex flex-col rounded-3xl p-4 mb-4'>
                    {infoData.map(a => <div className="bg-[#1E2021] w-full h-fit flex flex-col rounded-3xl p-4 mb-4">
                        <div className='w-full flex justify-center flex-col items-center'>
                        {a?.type === 'Torneo FIGT' ? <div className='bg-gradient-to-l from-[#EFEFFF] to-[#0000FF] flex w-fit rounded-full p-1 flex-row' >
                            <h1 className=' text-xs font-bold text-white uppercase'>
                                {a?.type}</h1>
                        </div>:
                        <div className='bg-[#3B934E] flex w-fit rounded-full p-1 flex-row' >
                            <h1 className=' text-xs font-bold text-white uppercase'>
                                {a?.type}</h1>
                        </div>
  }
                            <p className='text-base text-white pt-2 text-center'>{a.title}</p>
                            <h1 className='text-3xl font-black text-white first-letter:uppercase'>{new Date(a.date).toLocaleDateString('it-IT', { weekday: 'long', day: 'numeric', month: 'long' })}</h1>
                            <p className=' text-lg text-white'>{a?.time.slice(0, 5)} - {a?.end.slice(0, 5)}</p>
                            </div>
                          <div>
                            <h1 className=' text-base text-[#FFFFFF70] text-start mt-3'>Appuntamento: <h1 className='text-base text-white'>{a.where}</h1></h1>
                            <h1 className='text-base text-[#FFFFFF70] mt-1'>Campo: <h1 className='text-base text-white'>{a.campo}</h1></h1>
        
                            
                            <p className='text-base text-white'>{a?.info}</p>

                            <div className='flex flex-col w-full mt-2'>
                                <p className='text-base text-[#FFFFFF70]'>Presenti</p>
                                <div className='flex flex-row flex-wrap w-full mt-2'>
                                    {a?.member?.map(p => <p className='text-base text-white h-fit border border-white w-fit rounded-full p-1 m-1'>{p}</p>)}
                                </div>
                            </div>
                            <p className='text-xs text-white mt-4'>{a.desc}</p>
                            <p className='text-xs text-white'><strong>ATTENZIONE:</strong> Si raccomanda puntualità e di non lasciare il campo prima del termine. Verificate regolarmente eventuali variazioni di orario o campo. La lista sarà chiusa venerdì alle 23:00. In caso di rinuncia, avvisate un membro del direttivo entro sabato sera tramite telefono o WhatsApp. Le assenze non giustificate dopo l’iscrizione saranno considerate gravi.</p>
                        </div>
                        <button className='bg-[#839262] font-bold py-2 px-4 rounded-full mt-4 text-white w-full mr-2 text' onClick={() => addMember(a.id, nome, a?.member)}>{a.member !== null && a?.member.includes(nome) ? 'Cancella prenotazione' : 'Prenotati'}</button>
                        <button className='text-[#839262] border border-[#839262] font-bold py-2 px-4 rounded-full mt-4 w-full' onClick={() => setShowModal(false)}>Chiudi</button>
                    </div>

                    )}

                </div>
            </div>}

            {memo.length === 0 &&   <div className="bg-[#1E2021] w-full h-fit flex flex-col rounded-3xl p-4 mb-4">
                <h1 className='text-white font-bold text-2xl'>Nessuna attività in programma</h1>
                </div>}

            {memo.map(a =>
                <div className="bg-[#1E2021] w-full h-fit flex flex-col rounded-3xl p-4 mb-4">
                    <div className='flex flex-row'>
                        {a?.type === 'Torneo FIGT' ? <div className='bg-gradient-to-l from-[#EFEFFF] to-[#0000FF] flex w-fit rounded-full p-1 flex-row' >
                            <h1 className=' text-xs font-bold text-white uppercase'>
                                {a?.type}</h1>
                        </div>:
                        <div className='bg-[#3B934E] flex w-fit rounded-full p-1 flex-row' >
                            <h1 className=' text-xs font-bold text-white uppercase'>
                                {a?.type}</h1>
                        </div>
  }
                        <div className='border border-white w-fit rounded-full p-1 mx-2' >
                            <h1 className='text-xs font-bold text-white'>START: {a?.time.slice(0, 5)}</h1>
                        </div>
                        <div className='border border-white w-fit rounded-full p-1' >
                            <h1 className='text-xs font-bold text-white'>END: {a?.end.slice(0, 5)}</h1>
                        </div>
                    </div>
                    <h1 className='text-3xl pt-4 font-black text-white  '>
                        {a?.title}</h1>

                    {a.date && <h1 className='text-base  text-white first-letter:uppercase'>{new Date(a.date).toLocaleDateString('it-IT', { weekday: 'long', day: 'numeric', month: 'long' })}</h1>}

                    
                    {/* <div className='flex flex-row w-full mt-2'>
                    {a?.member?.map(p => <p className='text-base text-white bg-green-700 p-2 w-fit h-fit rounded-full aspect-square mr-1'>{p.match(/\b(\w)/g)}</p>)}
                </div> */}

                    <div className='flex flex-row justify-between'>
                        {a?.date >= formatToday && ( <button className='bg-[#839262] font-bold py-2 px-4 rounded-full mt-4 text-white w-full mr-2 text' onClick={() => addMember(a.id, nome, a?.member)}>{a.member !== null && a.member.includes(nome) ? 'Cancella prenotazione' : 'Prenotati'}</button>)} 
                    <button className='text-[#839262] border border-[#839262] font-bold py-2 px-4 rounded-full mt-4 w-full' onClick={() => navigation(`/info/${a.id}`)}>Mostra info</button>
                    </div>
                </div>)}
        </div>
    );
};

export default Card;
